import BaseChartCard from 'common/components/BaseChartCard'
import { useGetDeadShrimpLineChart } from 'modules/deadShrimp/api/queries'
import { useSpeciesName } from 'modules/pond/api/selector'
import { useTranslation } from 'react-i18next'
import DeadShrimpLineChart from '../DeadShrimpLineChart'
import { useTheme, Typography } from '@mui/material'
import useMedia from 'common/hooks/useMedia'

const ShrimpDeadChart = () => {
  const { t } = useTranslation('deadshrimp')
  const { refetch } = useGetDeadShrimpLineChart()
  const speciesName = useSpeciesName()
  const isMobile = useMedia('sm')
  const theme = useTheme()
  return (
    <BaseChartCard title={t('deadToday', { speciesName })} refresh={refetch}>
      {isMobile && (
        <Typography
          variant="caption"
          sx={{ fontWeight: theme.typography.fontWeightBold, color: theme.palette.text.secondary }}
        >
          {t('amount.kg')}
        </Typography>
      )}
      <DeadShrimpLineChart />
    </BaseChartCard >
  )
}

export default ShrimpDeadChart
